'use client';
import { useEffect } from 'react';
import s from './Gallery.module.scss';
import LazyImage from '@/components/common/LazyImage';
import { Image } from '@/types/common/ImageData';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel } from 'swiper/modules';

import 'swiper/css';

interface GalleryProps {
    data: DataProps;
}

interface DataProps {
    _type: string;
    _ref: string;
    gallery: Array<Image>;
}

export default function GalleryComponent({ data }: GalleryProps) {
    return (
        <div className={s.gallery}>
            <Swiper
                modules={[Mousewheel]}
                spaceBetween={13}
                slidesPerView={'auto'}
                centeredSlides={false}
                mousewheel={{ forceToAxis: true }}
                grabCursor={true}
                style={{ height: '70svh' }}
            >
                {data.gallery &&
                    data.gallery.map((item: Image, index: number) => (
                        <SwiperSlide key={`gallery-image-${index}`} style={{ width: 'auto' }}>
                            <div className={s.galleryImage}>
                                <LazyImage
                                    src={item.imageUrl}
                                    width={item.metadata.dimensions.width}
                                    height={item.metadata.dimensions.height}
                                    blurDataURL={item.ref}
                                    fill={false}
                                    alt={item.attribution || ''}
                                    caption={item.caption || null}
                                    filename={item.filename || ''}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
            </Swiper>
        </div>
    );
}